import {useEffect, useState} from "react";
import {customerFields} from "../../Utils/customerFormUtils";
import {useDispatch, useSelector} from "react-redux";
import {bindActionCreators} from "redux";
import formActionsImp from "../../Actions/formActions";
import customerActionsImp from "../../Actions/customerActions";
export default function useCustomerConnectionsCheck(form) {
    const dispatch = useDispatch();
    const formActions = bindActionCreators(formActionsImp, dispatch);
    const customerActions = bindActionCreators(customerActionsImp, dispatch);
    const customerConnections = useSelector((state) => state.CustomerReducer.customerConnections);
    const customer = useSelector((state) => state.CustomerReducer.customer);
    
    useEffect(() => {
        if (!customerConnections) {
            customerActions.getCustomerConnections(customer.vbCustomer.customerNumber);
        }
    }, []);

    useEffect(() => {
        if (!form) return;

        if (form?.data?.customerGroup === "1001" && customerConnections.some(c => c.product === "eEkonomi" && c.type === 1)) {
            formActions.updateFieldErrorFlags(form, customerFields.customerGroup.name, {customerGroup: "This Company is a Main customer and can't belong to 1001 Customer group"});
        }
    }, [form?.data?.customerGroup]);
}